import React, { useState, useGlobal } from 'reactn';
import Icon from '../../../_common/icons/ReturnIcons';
import { NeighbourStyled } from './neighbourStyled';
import Notification from "shared-anpost-components/components/notification";
import Button from '../../../_common/utils/Button';
import profileHooks from '../../../../hooks/profileHooks';
import { toANeighbourReq } from '../../../../services/Api';
import ErrorMessage from '../../errorMessage';
import { useEffect } from 'react';
import { virtualPageView } from '../../../../helpers/Helpers';


const ToNeighbourForm = ({ deliveryManagerResults }) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [neighbourName, setNeighbourName] = useState('');
    const [neighbourAddress, setNeighbourAddress] = useState('');
    const [successfullApiCall, setSuccessfullApiCall] = useGlobal("successfullApiCall");
    const [selectedTrackingItem, setSelectedTrackingItem] = useGlobal("selectedTrackingItem");
    const [apiError, setApiError] = useState(false);
    const baseURL = `${window.location.protocol}//${window.location.host}`;
    const tabTitle = document.title;

    const { values } = profileHooks();

    useEffect(() => {
        virtualPageView(`/myAccount/My-deliveries/delivery-options/neighbour`, `${tabTitle} - Delivery options - Neighbour`)
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        toANeighbourReq(values, {
            trackingNumber: selectedTrackingItem.trackingNumber,
            deliveryManagerRequestType: 3,
            deliveryManagerRequestDetail: `${neighbourName}, ${neighbourAddress}`,
            altDeliveryDt: null,
            altAddBuildingId: null,
            altAddSubBuildingId: null,
            altAddEircode: null,
            lockerId: null,
            disabledLocker: null
        }).then(res => {
            if (res.data.success) {
                setSuccessfullApiCall(true);
                setNeighbourAddress('');
                setNeighbourName('');

                virtualPageView(`/myAccount/My-deliveries/delivery-options/neighbour/success`, `${tabTitle} - Delivery options - Neighbour - Success`)
            }
        }).catch(() => {
            setApiError(true);
        })
    }

    const handleRetry = () => {
        setNeighbourAddress('');
        setNeighbourName('');
        setApiError(false);
    }

    return (
        <NeighbourStyled className='mainContent'>
            {!successfullApiCall ?
                <>
                    <div className='titleWrapper'>
                        <Icon src='houseIcon' />
                        <div className='headerTitle'>A neighbour</div>
                    </div>
                    {apiError ? <ErrorMessage message={"We're sorry but we couldn't load this delivery option"} tryAgainEvent={handleRetry} /> : <>

                        <div className='addressWrapper'>
                            <div className='semiTitle'>Delivery address</div>
                            <div className='addressInfo'>{selectedTrackingItem.recipientAddress.replace(/,/g, ', ')}</div>
                        </div>
                        <div>
                            <p className='formInfo'>Please enter your neighbours details</p>
                            <form>
                                <div className='inputWrapper'>
                                    <input maxLength={100} placeholder='Neighbour name' onChange={(e) => setNeighbourName(e.target.value)} />
                                    <input maxLength={100} placeholder='Neighbour address' onChange={(e) => setNeighbourAddress(e.target.value)} />
                                </div>
                                <div className='submitPanel'>
                                    {/* <div className='infoBoard'>
                                    <div><Icon src="outlineInfoIcon" /></div>
                                    <div>
                                        <strong className='infoTitle'>Delivery changes are final</strong>
                                        <p>Once you modify your delivery, no further changes can be made</p>
                                    </div>
                                </div> */}
                                    <Notification colour="blue" text="Delivery changes are final"
                                        additionalText="Once you modify your delivery, no further changes can be made" />
                                    <Button onClick={handleSubmit} type="submit" className="gtm-cta">Submit</Button>
                                </div>

                                <div className='termsWrapper'>
                                    <a className='terms' href="/Terms-Conditions" target="_self" rel="noopener noreferrer">
                                        Terms and Conditions
                                    </a>
                                    <a className='terms' href="/Privacy" target="_self" rel="noopener noreferrer">
                                        Privacy policy
                                    </a>
                                </div>
                            </form>
                        </div>
                    </>}
                </>
                :
                <>
                    <div className='titleWrapper'>
                        <Icon src='confirmIcon' />
                        <div className='headerTitle'>Confirmation</div>
                    </div>
                    <div className='confirmationLabel'>
                        Your delivery has been rearranged!
                    </div>

                </>
            }

        </NeighbourStyled>
    );
};

export default ToNeighbourForm;